@if (loading.main) {
<div class="d-flex justify-content-center align-items-center mt-5">
    <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>
} @else {
<breadcrumb [items]="breadcrumb" />
<h1 class="mb-0">{{ title }}</h1>
<hr class="mt-2" />
<div class="row">
    <div class="col-12 col-md-6 mb-3">
        <label for="docName">Nome</label>
        <input
            type="text"
            class="form-control"
            id="docName"
            name="docName"
            [(ngModel)]="doctor.name"
            required
        />
    </div>
    <div class="col-12 col-md-6 mb-3">
        <label for="docEmail">Email</label>
        <input
            type="email"
            class="form-control"
            id="docEmail"
            name="docEmail"
            [(ngModel)]="doctor.email"
            required
        />
    </div>
    <div class="col-12 col-md-6 mb-3">
        <label for="docCrm">CRM</label>
        <input
            type="text"
            class="form-control"
            id="docCrm"
            name="docCrm"
            [(ngModel)]="doctor.crm"
        />
    </div>
    <div class="col-12 col-md-6 mb-3">
        <label for="docCrmUf">CRM UF</label>
        <select
            class="form-control"
            id="docCrmUf"
            name="docCrmUf"
            [(ngModel)]="doctor.crm_uf"
        >
            <option value="" disabled selected>Selecione a UF</option>
            <option *ngFor="let uf of ufs" [value]="uf.sigla">
                {{ uf.sigla }} - {{ uf.nome }}
            </option>
        </select>
    </div>
    <div class="col-12 col-md-6 mb-3">
        <label for="docTelefone">Telefone</label>
        <input
            type="text"
            class="form-control"
            id="docTelefone"
            name="docTelefone"
            [(ngModel)]="doctor.phone"
            mask="(00) 00000-0000"
        />
    </div>
    <div class="col-12 col-md-6 mb-3" accessControl="ARIEL_ADMIN">
        <label for="doctorAtivoSwitch" class="form-label">É Admin?</label>
        <div class="form-check form-switch">
            <input
                class="form-check-input"
                type="checkbox"
                id="doctorAtivoSwitch"
                [(ngModel)]="doctorRole"
            />
            <label class="form-check-label" for="doctorAtivoSwitch">
                {{ doctorRole ? "Sim" : "Não" }}
            </label>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12 col-md-2 offset-md-8 order-2 order-md-1">
        <button class="btn btn-light w-100" [routerLink]="['/doctors']">
            Voltar
        </button>
    </div>
    <div class="col-12 col-md-2 mb-2 mb-md-0 order-1 order-md-2">
        <button
            class="btn btn-success w-100"
            (click)="saveDoctor()"
            [disabled]="!doctor.name || !doctor.email || loading.save"
        >
            <div
                class="spinner-border spinner-border-sm"
                role="status"
                *ngIf="loading.save"
            ></div>
            <span *ngIf="!loading.save">Salvar</span>
        </button>
    </div>
</div>
}
